// External libraries
import gql from 'graphql-tag';

export const COOKIE_BANNER_QUERY = gql`
  query CookieBannerQuery {
    cookieBanner {
      js
      css
      html
    }
  }
`;
